// Persian UI strings, grouped by feature.
export const fa = {
  appName: "میزبان‌فا — آف‌سایت",
  appShort: "آف‌سایت میزبان‌فا",

  nav: {
    dashboard: "داشبورد",
    servers: "سرورها",
    accounts: "اکانت‌ها",
    groups: "گروه‌ها و قوانین",
    excludes: "الگوهای استثنا",
    jobs: "کارها",
    snapshots: "اسنپ‌شات‌ها",
    storage: "ذخیره‌سازی",
    graveyard: "قبرستان",
    restore: "بازیابی",
    notifications: "اطلاع‌رسانی",
    ops: "عملیات",
    audit: "لاگ سیستم",
    settings: "تنظیمات",
    logout: "خروج",
    menu: "منو",
  },

  // «قبرستان» — آخرین نسخهٔ اکانتی که از فلیت خارج شده. متن‌ها عمداً توضیحی
  // نوشته شده‌اند: بیشتر اپراتورها اولین‌بار در همین صفحه با این مفهوم روبه‌رو
  // می‌شوند و باید بدون مراجعه به پایگاه‌داده بفهمند تفاوت «نسخهٔ واقعی cPanel»
  // با «بازسازی از restic» چیست و چرا این تفاوت مهم است.
  graveyard: {
    title: "قبرستان — آخرین نسخهٔ اکانت‌های حذف‌شده",
    subtitle: "پیش از حذف نهایی هر سرویس یک بکاپ کامل cPanel گرفته و روی دیسک اختصاصی نگه‌داری می‌شود",
    what:
      "پیش از آنکه سرویسی برای همیشه حذف شود، یک بکاپ کامل cPanel (pkgacct) از آن گرفته " +
      "و روی دیسک اختصاصی آرشیو نگه‌داری می‌شود. این نسخه مستقل از restic است و روی هر سرور " +
      "cPanel با restorepkg بازگردانی می‌شود؛ یعنی حتی بدون این سامانه هم قابل استفاده است.",
    retentionNote: (d: number) =>
      `مدت نگه‌داری ${d} روز از تاریخ خروج اکانت از فلیت است و همین تاریخ به مشتری اعلام می‌شود.`,
    provenanceTitle: "منشأ نسخه — چرا مهم است",
    provenanceHelp:
      "«نسخهٔ cPanel» یعنی خروجی مستقیم pkgacct از خود سرور، همان چیزی که به مشتری تحویل " +
      "داده می‌شود. «بازسازی از restic» یعنی اکانت پیش‌تر حذف شده بود و پنل، بستهٔ cpmove را " +
      "از اسنپ‌شات‌های باقی‌مانده سرِ هم کرده است؛ داده همان داده است اما بستهٔ اصلی cPanel نیست " +
      "و طبق سیاست سرویس هرگز نباید به مشتری تحویل شود.",
    sourcePkgacct: "نسخهٔ واقعی cPanel",
    sourceRestic: "بازسازی از restic",
    purposeTitle: "هدف نسخه",
    purposeHelp:
      "«آرشیو پیش از حذف» تنها چیزی است که قبرستان به‌حساب می‌آید: آخرین نسخه‌ای که درست پیش از " +
      "حذف دائمی سرویس گرفته شده و تا پایان مدت تعهد نگه‌داری می‌شود. «نسخهٔ درخواستی مشتری» یک " +
      "فایل موقتِ تحویل است، نه آرشیو؛ فقط تا زمان اعتبار لینک دانلود (به‌علاوهٔ یک روز) نگه " +
      "داشته می‌شود و در آمار پوشش و ظرفیت قبرستان شمرده نمی‌شود.",
    purposePreDeletion: "آرشیو پیش از حذف",
    purposeOnDemand: "نسخهٔ درخواستی مشتری",
    purposeShortPreDeletion: "پیش از حذف",
    purposeShortOnDemand: "درخواستی",
    transient: (n: string, size: string) =>
      `${n} نسخهٔ درخواستی مشتری روی همین دیسک است (${size}). این‌ها آرشیو نیستند و در ارقام بالا شمرده نشده‌اند.`,
    sourceShortPkgacct: "cPanel",
    sourceShortRestic: "restic",
    fallbackOn: "بازسازی از restic فعال است — درخواست آرشیو برای اکانت حذف‌شده به نسخهٔ بازسازی‌شده تبدیل می‌شود.",
    fallbackOff: "بازسازی از restic غیرفعال است — درخواست آرشیو برای اکانت حذف‌شده صریحاً رد می‌شود.",

    tabs: {
      inventory: "فهرست آرشیوها",
      coverage: "پوشش مشتری",
      failures: "خطاها",
      health: "سلامت خط لوله",
    },

    capacity: {
      title: "ظرفیت دیسک آرشیو",
      used: "مصرف فعلی",
      total: "ظرفیت دیسک",
      required: "نیاز در پوشش کامل",
      shortfall: "کسری ظرفیت",
      headroom: "فرصت باقی‌مانده",
      days: "روز",
      tb: "ترابایت",
      rate: (n: number) => `نرخ واقعی حذف سرویس: ${n} اکانت در روز`,
      captureRate: (n: number) => `نرخ درخواست آرشیو در ۲۸ روز اخیر: ${n} در روز`,
      avg: (s: string) => `میانگین حجم هر آرشیو: ${s}`,
      accepting: "دیسک فضای کافی دارد.",
      evicting:
        "دیسک پر شده است و برای گرفتن آرشیو جدید، قدیمی‌ترین آرشیوها حذف می‌شوند. " +
        "گرفتن بکاپ هرگز به دلیل پر بودن دیسک متوقف نمی‌شود.",
      shortfallWarn: (tb: string, days: string) =>
        `با مدت نگه‌داری فعلی و نرخ واقعی حذف سرویس‌ها، ${tb} ترابایت فضای بیشتر لازم است. ` +
        `با روند فعلی تا حدود ${days} روز دیگر ناچار به حذف آرشیوهای درون بازهٔ تعهد می‌شویم — ` +
        `سفارش دیسک باید پیش از آن انجام شود.`,
    },

    funnel: {
      title: (d: number) => `خط لوله در ${d} روز گذشته`,
      terminated: "اکانت حذف‌شده",
      covered: "دارای آرشیو",
      requested: "درخواست‌شده",
      dispatched: "ارسال به سرور",
      stored: "ذخیره‌شده",
      pending: "در جریان",
      failed: "ناموفق",
      hint: "اگر عددی بین دو مرحله افت شدید دارد، گلوگاه همان مرحله است.",
    },

    sweep: {
      title: "آخرین اجرای نظافت",
      last: "آخرین اجرا",
      next: "اجرای بعدی",
      never: "هرگز اجرا نشده",
      purged: "آرشیو منقضی حذف‌شده",
      deliveriesExpired: "لینک منقضی جمع‌شده",
      rescheduled: "تاریخ انقضا اصلاح‌شده",
      run: "اجرای فوری نظافت",
    },

    columns: {
      account: "اکانت",
      server: "سرور",
      service: "شناسهٔ سرویس",
      size: "حجم",
      state: "وضعیت",
      source: "منشأ",
      taken: "تاریخ تهیه",
      expires: "نگه‌داری تا",
      delivery: "تحویل",
      actions: "عملیات",
    },
    states: {
      pending: "در جریان",
      stored: "ذخیره‌شده",
      failed: "ناموفق",
      purged: "حذف‌شده",
    },
    delivery: {
      none: "—",
      placing: "در حال آماده‌سازی",
      ready: "لینک فعال",
      failed: "ناموفق",
      expires: (s: string) => `تا ${s}`,
      host: "نسخهٔ دانلود روی هاست offback (offback.mizbanfadevops.com) قرار می‌گیرد و پس از انقضا خودکار پاک می‌شود.",
    },

    filters: {
      search: "جست‌وجوی اکانت یا شناسهٔ سرویس",
      allStates: "همهٔ وضعیت‌ها",
      allSources: "همهٔ منشأها",
      allPurposes: "همه (شامل نسخه‌های موقت)",
      allServers: "همهٔ سرورها",
      expiringSoon: "نزدیک به انقضا (۳۰ روز)",
      sortTaken: "جدیدترین",
      sortSize: "بزرگ‌ترین",
      sortExpires: "نزدیک‌ترین انقضا",
      reset: "پاک‌سازی",
      empty: "هیچ آرشیوی با این فیلترها پیدا نشد.",
      emptyAll: "هنوز هیچ آرشیوی گرفته نشده است.",
    },

    coverage: {
      title: "آیا این مشتری پوشش دارد؟",
      hint: "نام کاربری cPanel یا شناسهٔ سرویس WHMCS را وارد کنید.",
      check: "بررسی",
      covered: "آرشیو معتبر موجود است",
      notCovered: "آرشیو معتبری موجود نیست",
      takenOn: "تاریخ تهیه",
      keptUntil: "نگه‌داری تا",
      size: "حجم",
      source: "منشأ",
      attempts: "تلاش‌های ثبت‌شده",
      accountDeleted: "این اکانت از فلیت حذف شده است.",
      noResult: "برای این شناسه نه اکانتی پیدا شد و نه آرشیوی.",
    },

    failures: {
      title: "خطاها بر اساس علت",
      hint: "علت‌های «قابل جبران» با تلاش دوباره یا نجات اکانت‌های حذف‌شده قابل رفع‌اند.",
      recoverable: "قابل جبران",
      permanent: "غیرقابل جبران",
      count: "تعداد",
      cause: "علت",
      sample: "نمونهٔ پیام",
      none: "هیچ خطایی ثبت نشده است.",
      causes: {
        account_deleted: "اکانت پیش‌تر حذف شده بود",
        no_snapshots: "حذف‌شده و بدون اسنپ‌شات سالم",
        undispatched: "سرور کار را نپذیرفت",
        artifact_gone: "فایل روی ایجنت پیدا نشد",
        transfer: "انتقال فایل قطع شد",
        pkgacct_failed: "خود pkgacct ناموفق بود",
        restic_build: "بازسازی از restic ناموفق بود",
        too_large: "حجم اکانت بیش از حد مجاز",
        other: "سایر",
      },
    },

    actions: {
      capture: "گرفتن آرشیو",
      captureHint: "برای اکانتی که هنوز روی فلیت است، یک بکاپ کامل cPanel گرفته می‌شود. اگر آرشیو تازه‌ای موجود باشد همان بازگردانده می‌شود.",
      capturePlaceholder: "نام کاربری cPanel",
      deliver: "ساخت لینک دانلود",
      deliverHint: "یک نسخه از آرشیو روی هاست دانلود کپی و لینک موقت ساخته می‌شود. این کار چند دقیقه طول می‌کشد.",
      revoke: "ابطال لینک",
      revokeHint: "لینک بلافاصله از کار می‌افتد و نسخهٔ کپی‌شده از هاست دانلود پاک می‌شود.",
      retry: "تلاش دوباره",
      retryHint: "درخواست دوباره در صف pkgacct قرار می‌گیرد. برای اکانتی که حذف شده باشد کار نمی‌کند.",
      purge: "حذف آرشیو",
      purgeHint: "فایل آرشیو برای همیشه پاک می‌شود. این تنها نسخهٔ باقی‌ماندهٔ سایت مشتری است.",
      purgeConfirm: (u: string) => `برای تأیید، نام «${u}» را وارد کنید:`,
      purgeReason: "دلیل حذف (در لاگ ثبت می‌شود)",
      rescue: "نجات اکانت‌های حذف‌شده",
      rescueHint: "آرشیوهای ناموفقِ اکانت‌های حذف‌شده که هنوز اسنپ‌شات دارند دوباره در صف قرار می‌گیرند. خروجی این کار «بازسازی از restic» است.",
      rescueDry: "پیش‌نمایش",
      cancel: "انصراف",
      confirm: "تأیید",
    },
  },

  snapshots: {
    title: "اسنپ‌شات‌ها",
    subtitle: "فهرست کامل بکاپ‌های فایل، دیتابیس و تنظیمات — قابل فیلتر و بازبینی",
    filters: {
      server: "سرور",
      account: "اکانت",
      kind: "نوع",
      valid: "وضعیت",
      allServers: "همهٔ سرورها",
      allAccounts: "همهٔ اکانت‌ها",
      allKinds: "همهٔ انواع",
      allValid: "همه",
      validOnly: "فقط سالم",
      invalidOnly: "فقط خراب",
      includePruned: "نمایش حذف‌شده‌ها",
      reset: "پاک‌سازی فیلترها",
    },
    columns: {
      created: "زمان ایجاد",
      server: "سرور",
      account: "اکانت",
      kind: "نوع",
      dbName: "نام دیتابیس",
      size: "حجم",
      valid: "سلامت",
      verified: "آخرین بازبینی",
      restic: "شناسهٔ restic",
      actions: "عملیات",
    },
    kindLabels: {
      files: "فایل‌های اکانت",
      db: "دادهٔ دیتابیس",
      db_create: "اسکیمای دیتابیس",
      db_meta: "متادیتای MySQL",
      meta: "تنظیمات cPanel",
      cpmove: "بستهٔ cpmove",
    },
    valid: "سالم",
    invalid: "خراب",
    pruned: "حذف‌شده",
    notVerified: "هنوز بازبینی نشده",
    verify: "بازبینی مجدد",
    verifying: "در حال بازبینی…",
    verifyOk: (n: number) => `${n} اسنپ‌شات سالم، بازبینی موفق`,
    verifyFail: (msg: string) => `بازبینی ناموفق: ${msg}`,
    empty: "هیچ اسنپ‌شاتی مطابق فیلتر یافت نشد",
    showing: (from: number, to: number, total: number) =>
      `نمایش ${from.toLocaleString("en-US")}–${to.toLocaleString("en-US")} از ${total.toLocaleString("en-US")}`,
    next: "بعدی",
    prev: "قبلی",
  },

  notif: {
    title: "اطلاع‌رسانی",
    subtitle: "کانال‌های ارسال هشدار (شکست بکاپ، پر شدن دیسک، خطاهای سیستم)",
    add: "افزودن کانال",
    test: "ارسال پیام تست",
  },
  settings: {
    title: "تنظیمات",
    concurrency: "همزمانی پردازش",
    globalMaxJobs: "حداکثر کارهای همزمان (در کل سیستم)",
    bandwidthMBps: "سقف پهنای‌باند کلی (مگابایت بر ثانیه)",
    retention: "نگه‌داری اسنپ‌شات‌ها",
    defaultRetentionDays: "تعداد روز پیش‌فرض نگه‌داری اسنپ‌شات‌ها",
    killswitch: "قطع کامل سیستم",
    orphan: {
      title: "حذف خودکار بکاپ اکانت‌های پاک‌شده از cPanel",
      hint:
        "وقتی یک اکانت در cPanel کاملاً حذف می‌شود (پس از suspend)، " +
        "در همگام‌سازی بعدی، رکوردش در سیستم ما به‌عنوان «حذف‌شده» علامت می‌خورد. " +
        "این مقدار تعیین می‌کند چند روز بعد از آن، تمام اسنپ‌شات‌های آن اکانت " +
        "از مخزن حذف فیزیکی شوند. توصیه: حداقل 30 روز برای فرصت بازیابی اشتباه‌های اپراتور.",
      label: "تعداد روز انتظار بعد از حذف در cPanel",
      pendingNow: "اکانت‌های پاک‌شده‌ای که در پاک‌سازی بعدی حذف می‌شوند",
      pendingNext24h: "اکانت‌هایی که تا 24 ساعت آینده مشمول حذف می‌شوند",
      pendingTotal: "کل اکانت‌های پاک‌شده ولی هنوز در مخزن",
      previewWith: (n: number) => `پیش‌نمایش با مقدار ${n} روز`,
      sampleHeading: "نمونهٔ فهرست (حداکثر 10 مورد)",
      noPending: "هیچ اکانت پاک‌شده‌ای منتظر حذف نیست.",
      configured: (n: number) => `مقدار فعلی: ${n} روز`,
      defaultIs: (n: number) => `(پیش‌فرض سیستم: ${n} روز)`,
    },
    graveyard: {
      title: "آرشیو گورستان (آخرین نسخهٔ اکانت‌های حذف‌شده)",
      hint:
        "سه روز پیش از حذف نهایی یک سرویس، یک بکاپ کامل cPanel از آن گرفته و روی " +
        "دیسک اختصاصی آرشیو نگه‌داری می‌شود. این نسخه مستقل از restic است و روی هر " +
        "سرور cPanel با restorepkg بازگردانی می‌شود.",
      retentionDays: "مدت نگه‌داری آرشیو پس از حذف سرویس (روز)",
      maxSizeGb: "حداکثر حجم اکانت برای آرشیو (گیگابایت)",
      minFreePct: "حداقل فضای آزاد دیسک آرشیو (درصد)",
      minFreeHint:
        "اگر فضای آزاد از این مقدار کمتر شود، آرشیو جدیدی گرفته نمی‌شود و هشدار " +
        "ذخیره‌سازی ارسال می‌شود. پر شدن این دیسک یعنی از دست رفتن آخرین نسخهٔ " +
        "همهٔ اکانت‌های دیگر، پس رد کردن یک آرشیو کم‌هزینه‌تر است.",
      capacityTitle: "وضعیت و پیش‌بینی ظرفیت",
      used: "مصرف فعلی",
      total: "ظرفیت دیسک",
      required: "نیاز در حالت پایدار",
      shortfall: "کسری ظرفیت",
      rate: (n: number) => `نرخ درخواست ۲۸ روز اخیر: ${n} آرشیو در روز`,
      avg: (s: string) => `میانگین حجم هر آرشیو: ${s}`,
      accepting: "در حال پذیرش آرشیو جدید",
      notAccepting: "پذیرش آرشیو جدید متوقف شده — دیسک پر است",
      shortfallWarn:
        "با نرخ فعلی و مدت نگه‌داری تعیین‌شده، این دیسک کفایت نمی‌کند. " +
        "یا ظرفیت را افزایش دهید یا مدت نگه‌داری را کوتاه‌تر کنید.",
      tb: "ترابایت",
    },
    users: {
      title: "کاربران پنل",
      add: "افزودن کاربر",
      username: "نام کاربری",
      email: "ایمیل",
      fullName: "نام و نام خانوادگی",
      role: "نقش",
      password: "رمز عبور",
      lastLogin: "آخرین ورود",
      mfa: "ورود دو‌مرحله‌ای",
      mfaOn: "فعال",
      mfaOff: "غیرفعال",
      resetPw: "تغییر رمز عبور",
      resetTotp: "بازنشانی ورود دو مرحله‌ای",
      disable: "غیرفعال‌سازی",
    },
    totp: {
      title: "ورود دو مرحله‌ای (TOTP)",
      enable: "فعال‌سازی",
      disable: "غیرفعال‌سازی",
      enabled: "ورود دو مرحله‌ای فعال است.",
      disabled: "ورود دو مرحله‌ای غیرفعال است.",
      hint:
        "بعد از وارد کردن رمز عبور، یک کد 6 رقمی از اپلیکیشن TOTP " +
        "(Google Authenticator، 1Password، Bitwarden، Authy) از شما خواسته می‌شود. " +
        "اپلیکیشن خود را با QR زیر همگام کنید، سپس کد فعلی را وارد کنید.",
      secret: "کلید متنی (در صورت عدم اسکن QR)",
      code: "کد فعلی اپلیکیشن",
      currentPassword: "رمز عبور فعلی (برای غیرفعال‌سازی)",
    },
  },
  audit: {
    title: "لاگ سیستم",
    subtitle: "ثبت همهٔ اقدامات اپراتورها و کلیدهای API بیرونی — فقط افزودنی.",
    actor: "اپراتور",
    action: "اقدام",
    target: "مورد هدف",
    ip: "آی‌پی",
  },

  restore: {
    title: "بازیابی",
    newRestore: "بازیابی جدید",
    pickAccount: "انتخاب اکانت",
    pickType: "مقصد بازیابی",
    targetDownload: "تولید لینک دانلود امن",
    targetHomedir: "قرار دادن در پوشهٔ خانگی روی سرور مبدأ",
    targetFull: "بازیابی کامل روی سرور cPanel هدف",
    targetServer: "سرور هدف",
    expiresIn: "اعتبار لینک (ساعت)",
    snapshots: "اسنپ‌شات‌های انتخاب‌شده",
    autoRecommend: "پیشنهاد خودکار آخرین مجموعهٔ سالم",
    restorePoint: "نقطهٔ بازیابی (تاریخ نسخه)",
    restorePointLatest: "آخرین نسخهٔ سالم (خودکار)",
    restorePointHint: "نسخهٔ مربوط به یک تاریخ مشخص را برای بازیابی انتخاب کنید؛ سایر اجزا (متادیتا و دیتابیس) متناسب با همان لحظه انتخاب می‌شوند.",
    restorePointEmpty: "نسخهٔ زمان‌مند دیگری برای انتخاب موجود نیست.",
    submit: "ثبت درخواست",
    downloadUrl: "لینک دانلود",
    copyUrl: "کپی",
    revoke: "ابطال",
    states: {
      pending: "در صف",
      preparing: "در حال آماده‌سازی",
      ready: "آمادهٔ دانلود",
      failed: "ناموفق",
      expired: "منقضی",
      revoked: "ابطال‌شده",
    },
    // For cpanel_full / cpanel_homedir restores there is no download — the
    // `ready` state means the cpmove was applied on the target server. Show a
    // clearer label than the generic "آمادهٔ دانلود".
    appliedFull: "اعمال شد",
    appliedHomedir: "کپی شد",
    accessLogs: "تاریخچهٔ دسترسی",
    bytesServed: "حجم ارسالی",
  },

  auth: {
    title: "ورود به پنل",
    subtitle: "برای ورود از نام کاربری و رمز عبور خود استفاده کنید",
    username: "نام کاربری",
    email: "ایمیل",
    password: "رمز عبور",
    submit: "ورود",
    submitting: "در حال ورود...",
    invalid: "نام کاربری یا رمز عبور نادرست است.",
    locked: "حساب موقتاً مسدود است؛ بعداً تلاش کنید.",
  },

  common: {
    yes: "بله",
    no: "خیر",
    save: "ذخیره",
    cancel: "انصراف",
    confirm: "تأیید",
    delete: "حذف",
    edit: "ویرایش",
    refresh: "تازه‌سازی",
    search: "جستجو…",
    filter: "فیلتر",
    all: "همه",
    loading: "در حال بارگذاری…",
    empty: "موردی یافت نشد.",
    error: "خطا در دریافت داده",
    actions: "اقدامات",
    name: "نام",
    state: "وضعیت",
    createdAt: "تاریخ ایجاد",
    updatedAt: "تاریخ به‌روزرسانی",
    size: "حجم",
    count: "تعداد",
    duration: "مدت",
    retry: "تلاش مجدد",
    close: "بستن",
  },

  dashboard: {
    title: "داشبورد",
    kpiServers: "سرورها",
    kpiAccounts: "اکانت‌ها",
    kpiCommercial: "کاربران ویژه",
    kpiCommercialSub: "مشاهدهٔ همه",
    kpiRunningJobs: "کارهای در حال اجرا",
    kpiErrors24h: "خطاهای 24 ساعت اخیر",
    kpiStorageUsed: "حجم مصرفی ذخیره‌سازی",
    kpiStorageFree: "حجم آزاد ذخیره‌سازی",
    kpiAvgSpeed: "میانگین سرعت بکاپ",
    kpiAvgSpeedHint:
      "حجم منطقی بکاپ ÷ زمان کلی هر جاب. شامل pkgacct، mysqldump، فشرده‌سازی restic و ارسال شبکه است؛ پس عددی برای «ظرفیت کلی pipeline» است نه سرعت لحظه‌ای شبکه. سرعت لحظه‌ای شبکه را با wget یا iperf روی همان سرور تست کنید.",
    kpiStorageUsedHint:
      "حجم واقعی روی دیسک بعد از فشرده‌سازی و حذف افزونگی (deduplication). حجم منطقی (سایز اصلی همه‌ی اسنپ‌شات‌ها) معمولاً چند برابر بزرگ‌تر است؛ ضریب صرفه‌جویی نشان می‌دهد چقدر فضا ذخیره شده.",
    kpiUptime: "میانگین در دسترس‌بودن سرورها",
    serverGrid: "وضعیت سرورها",
    recentJobs: "کارهای اخیر",
    corrupted: "اکانت‌های دارای مشکل",
  },

  servers: {
    title: "سرورها",
    add: "افزودن سرور",
    host: "آدرس",
    port: "پورت",
    agent: "وضعیت ایجنت",
    online: "آنلاین",
    offline: "آفلاین",
    diskTarget: "دیسک مقصد",
    assignedAccounts: "اکانت‌های منتسب",
    enable: "فعال‌سازی",
    disable: "غیرفعال‌سازی",
    pingAgent: "تست ارتباط با ایجنت",
    drain: "توقف موقت (دیگر کار جدید نگیرد)",
    undrain: "بازگشت به حالت فعال",
    bulkBackupServer: "بکاپ همهٔ اکانت‌های این سرور",
    wipeServer: "حذف کامل تمام بکاپ‌های این سرور",
    wipePrompt: (n: string) =>
      `برای تأیید پاک کردنِ تمام اسنپ‌شات‌های «${n}»، نام دقیقاً همان سرور را تایپ کنید. این عملیات قابل بازگشت نیست.`,
    wipeSuccess: (n: number) => `${n.toLocaleString("en-US")} اسنپ‌شات حذف شد`,
    drainedNow: "سرور در حالت توقف موقت قرار گرفت — کار جدید نمی‌گیرد",
    undrainedNow: "سرور به حالت فعال بازگشت",
  },

  accounts: {
    title: "اکانت‌ها",
    user: "کاربر",
    domain: "دامنه",
    server: "سرور",
    group: "گروه",
    lastFull: "آخرین بکاپ کامل",
    lastDb: "آخرین بکاپ دیتابیس",
    sizeOnDisk: "حجم روی دیسک",
    backupNow: "بکاپ‌گیری دستی",
    history: "تاریخچه",
    commercial: "تجاری",
    suspended: "معلق",
    grace: "معتبر تا",
  },

  groups: {
    title: "گروه‌ها و قوانین",
    add: "افزودن گروه",
    fullEvery: "بکاپ کامل هر چند روز",
    dbEvery: "بکاپ دیتابیس هر چند ساعت",
    keepFull: "نگه‌داری بکاپ کامل (روز)",
    keepDb: "نگه‌داری بکاپ دیتابیس (روز)",
    blackout: "بازه‌های ممنوعه",
    paid: "پولی",
    free: "رایگان",
  },

  jobs: {
    title: "کارهای بکاپ‌گیری",
    kind: "نوع",
    server: "سرور",
    account: "اکانت",
    started: "شروع",
    finished: "پایان",
    duration: "مدت",
    durationRunning: "در حال اجرا — {d}",
    durationDone: "تمام شد در {d}",
    progress: "پیشرفت",
    cancel: "لغو",
    logs: "گزارش زنده",
    states: {
      queued: "در انتظار اجرا",
      success: "موفق",
      partial_success: "موفقیت ناقص",
      pending: "در انتظار اجرا",
      running: "در حال اجرا",
      done: "موفق",
      failed: "ناموفق",
      cancelled: "لغو شده",
    },
    kinds: {
      account_full: "بکاپ کامل (فایل + دیتابیس + تنظیمات)",
      account_db: "بکاپ دیتابیس",
      account_meta: "بکاپ تنظیمات اکانت",
      account_pkgacct: "آرشیو قبرستان (پیش از حذف سرویس)",
      restore_full: "بازیابی کامل",
      restore_granular: "بازیابی جزئی",
      verify: "بازبینی سلامت اسنپ‌شات",
      prune: "پاک‌سازی نسخه‌های قدیمی",
      inventory_sync: "همگام‌سازی فهرست اکانت‌ها",
    },
    kindsShort: {
      account_full: "کامل",
      account_db: "دیتابیس",
      account_meta: "تنظیمات",
      account_pkgacct: "قبرستان",
      restore_full: "بازیابی",
      restore_granular: "بازیابی جزئی",
      verify: "بازبینی",
      prune: "پاک‌سازی",
      inventory_sync: "همگام‌سازی",
    },
    empty: "هنوز هیچ کاری ثبت نشده است.",
    staleHint:
      "این کار بیش از حد معمول در انتظار است — احتمالاً ایجنت ری‌استارت شده. " +
      "سرویس بازآشتی به‌طور خودکار ظرف 90 ثانیه آن را بررسی می‌کند.",
  },

  ops: {
    title: "عملیات و مدیریت",
    killAll: "توقف کامل سیستم",
    resumeAll: "ازسرگیری سیستم",
    killServer: "توقف موقت این سرور",
    resumeServer: "ازسرگیری این سرور",
    rotateDisk: "انتقال مخزن به دیسک دیگر",
    deleteServerBackups: "حذف کامل تمام بکاپ‌های یک سرور",
    bulkUpload: "اجرای بکاپ دسته‌ای",
    runScheduler: "اجرای دستی موتور خودکار",
    runVerifier: "بازبینی سلامت همهٔ اسنپ‌شات‌ها",
    runPruner: "اجرای پاک‌سازی نسخه‌های قدیمی",

    bulkBackup: {
      title: "بکاپ دسته‌ای فوری",
      hint:
        "تا حداکثر «تعداد» اکانتِ مطابق فیلتر (سرور و/یا گروه) با اولویت بالا در صف قرار می‌گیرند. " +
        "محدودیت‌های همزمانی همچنان رعایت می‌شوند؛ اگر حداکثر همزمانی 2 باشد، کارها صف می‌بندند و یکی‌یکی اجرا می‌شوند.",
      scope: "محدوده",
      scopeAll: "همهٔ سرورهای فعال",
      scopeServer: "فقط این سرور",
      scopeGroup: "فقط این گروه",
      kind: "نوع",
      limit: "حداکثر تعداد",
      submit: "شروع",
      submitted: (queued: number, skipped: number) =>
        `${queued.toLocaleString("en-US")} در صف، ${skipped.toLocaleString("en-US")} رد‌شده (سقف همزمانی)`,
    },

    seed: {
      title: "بکاپ اولیهٔ کل ناوگان",
      hint:
        "برای گرفتن اولین بکاپ کامل از همهٔ سرورها. پیشرفت در پایگاه‌داده ذخیره می‌شود؛ " +
        "اگر پنل ری‌استارت شود، از همان نقطه ادامه پیدا می‌کند. " +
        "اکانت‌های کوچک‌تر ابتدا پردازش می‌شوند تا برآیند سریع‌تر دیده شود.",
      start: "شروع",
      stop: "توقف",
      running: "در حال اجرا",
      stopped: "متوقف",
      progress: (done: number, total: number) =>
        `${done.toLocaleString("en-US")} / ${total.toLocaleString("en-US")}`,
      submitted: "ارسال‌شده",
      skipped: "رد‌شده (سقف همزمانی یا قبلاً انجام)",
      lastError: "آخرین خطا",
      notStarted: "هنوز شروع نشده. روی «شروع» بزنید.",
    },

    orphan: {
      title: "پاک‌سازی اکانت‌های حذف‌شده",
      hint: "همان جریان «تنظیمات» — اینجا با امکان اجرای آزمایشی (Dry-run) و اجرای واقعی.",
      runDry: "اجرای آزمایشی (بدون حذف)",
      runReal: "اجرای واقعی",
      result: (forgotten: number, archived: number) =>
        `${forgotten.toLocaleString("en-US")} اسنپ‌شات حذف، ${archived.toLocaleString("en-US")} مورد بایگانی شد`,
    },
  },

  excludes: {
    title: "الگوهای استثنا برای بکاپ فایل‌ها",
    newSet: "مجموعهٔ جدید",
    sets: "مجموعه‌ها",
    editor: "ویرایشگر",
    name: "نام",
    description: "توضیحات",
    patterns: "الگوها",
    patternPlaceholder: "مثلاً */tmp/* یا */.cache/*",
    patternCount: (n: number) => `${n} الگو`,
    usedBy: (n: number) => `استفاده در ${n} قانون`,
    system: "پیش‌فرض سیستم",
    empty: "هنوز هیچ مجموعه‌ای ساخته نشده.",
    save: "ذخیره",
    delete: "حذف",
    removePattern: "حذف الگو",
    toastCreated: "مجموعه ساخته شد",
    toastSaved: "تغییرات ذخیره شد",
    toastDeleted: "مجموعه حذف شد",
    confirmDelete: (name: string) =>
      `مطمئنید می‌خواهید «${name}» را حذف کنید؟`,
  },

  storage: {
    title: "وضعیت ذخیره‌سازی",
    free: "آزاد",
    mountedAt: "محل اتصال:",
    daysUntilFull: (n: number) => `${n} روز تا پر شدن`,
    totalsLine: (used: string, total: string) =>
      `${used} از ${total} استفاده شده`,
    forecastTitle: "پیش‌بینی پر شدن دیسک (14 روز اخیر)",
    forecastEmpty: "هنوز داده‌ای برای پیش‌بینی موجود نیست.",
    forecastWindowNote: (days: number) =>
      `پیش‌بینی بر اساس رشد ${days} روز اخیر حجم اسنپ‌شات‌ها محاسبه می‌شود.`,
    disk: "دیسک",
    growthPerDay: "رشد روزانه",
    daysLeft: "روز تا پر شدن",
    confidence: "اطمینان",
  },

} as const;

export type Locale = typeof fa;
